"use client";

import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import styles from "./SignIn.module.css";
import { FaEnvelope, FaLock, FaExclamationCircle } from "react-icons/fa";
import pencil from "../assets/pencil.png";
import login1 from "../assets/login1.png";
import login2 from "../assets/login2.png";
import Footer from "../MyComponents/Footer";
import GuestNav from "./Navbars/GuestNav";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const SignIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const formType = searchParams.get('form');
    if (formType === 'signup') {
      setIsLogin(false);
    }
  }, [location]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Input ${name} changed to: ${value}`);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          loginEmail: formData.email,
          loginPassword: formData.password,
        }),
      });

      const data = await response.json();
      if (data.Login) {
        toast.success('Successfully Logged In', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate('/');
      } else {
        toast.error('Incorrect email or password!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Login failed!', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.authPage}>
        <GuestNav />
        <div className={styles.spacer}></div>
        <div className={styles.authContainer}>
          <img src={login1} alt="Login decoration 1" className={`${styles.loginImage} ${styles.loginImage1}`} />
          <img src={login2} alt="Login decoration 2" className={`${styles.loginImage} ${styles.loginImage2}`} />
          <div className={styles.authFormWrapper}>
            <div className={styles.headerContainer}>
              <img src={pencil} alt="Pencil icon" className={styles.pencilIcon} />
              <h1 className={styles.authTitle}>Log In to Polymath Kids</h1>
            </div>
            <form className={styles.authForm} onSubmit={handleSubmit}>
              <div className={styles.formGroupEmailField}>
                <div className={styles.inputWrapper}>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                    onClick={(e) => console.log('Email input clicked!', e.target)}
                    className={errors.email ? `${styles.error}` : ""}
                  />
                  <FaEnvelope className={styles.inputIcon} />
                </div>
                {errors.email && (
                  <span className={styles.errorMessage}>
                    <FaExclamationCircle /> {errors.email}
                  </span>
                )}
              </div>

              <div className={styles.formGroupPasswordField}>
                <div className={styles.inputWrapper}>
                  <input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    onClick={(e) => console.log('Password input clicked!', e.target)}
                    className={errors.password ? `${styles.error}` : ""}
                  />
                  <FaLock className={styles.inputIcon} />
                </div>
                {errors.password && (
                  <span className={styles.errorMessage}>
                    <FaExclamationCircle /> {errors.password}
                  </span>
                )}
              </div>

              <button type="submit" className={styles.authButton} disabled={loading}>
                {loading ? 'Logging In...' : 'Login'}
              </button>

              <div className={styles.authLinks}>
                <p className={styles.registerLink}>
                  Don't have an account?{" "}
                  <Link to="/signup" className={styles.registerText}>
                    Register
                  </Link>
                </p>
                <Link to="/forgot-password" className={styles.forgotPasswordLink}>
                  Forgot Password?
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default SignIn;